import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MENU_FILTERS } from './tokens/menu-filter.token';
import { LoyaltyMenuFilterService } from './services/loyalty-menu-filter.service';
import { LoyaltyMenuClickHandlerService } from './services/loyalty-menu-click-handler.service';
import { MENU_CLICK_HANDLERS } from './tokens/menu-click-handler.token';

/**
 * Provides shared tokens from all modules to be used within menu logic
 * Custom tokens should be provided before initialization of menu components
 * Therefore they can not be provided by (potentially) lazy loaded modules
 */
@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: MENU_FILTERS,
      useFactory: menuFilterFactory,
      deps: [LoyaltyMenuFilterService],
      multi: true,
    },
    {
      provide: MENU_CLICK_HANDLERS,
      useFactory: menuClickHandlerFactory,
      deps: [LoyaltyMenuClickHandlerService],
      multi: true,
    },
  ]
})
export class MenuModule {}

export function menuFilterFactory(menuFilter: LoyaltyMenuFilterService) {
  return menuFilter;
}

export function menuClickHandlerFactory(menuClickHandler: LoyaltyMenuClickHandlerService) {
  return menuClickHandler;
}
